import "./weatherApp.css";
import Main from "../components/weatherApp/main";

const WeatherApp = () => {
  return (
    <div className="weatherApp">
      <Main />
    </div>
  );
};

export default WeatherApp;
